import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "badges badges-route" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "badges badges-route" }

import { ref } from 'vue';
import { clubUUID } from '@/shared/state';
import { usePermission } from "@/composables/auth/usePermission";


export default /*#__PURE__*/_defineComponent({
  __name: 'memberRoute',
  props: {
    memberUUID: {
        type: String,
        default: '',
    },
    matricule: {
        type: String,
        default: '',
    }
},
  setup(__props) {

const props = __props;

const memberUUID = ref(props?.memberUUID);
const matricule = ref(props?.matricule);

const { hasPermission } = usePermission();


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(hasPermission)('fiche_member') && memberUUID.value)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        class: "bg-none",
        to: { name: 'fiche', params: { clubUUID: _unref(clubUUID), memberUUID: memberUUID.value } }
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(matricule.value), 1)
        ]),
        _: 1
      }, 8, ["to"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(matricule.value), 1)
      ]))
}
}

})